//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            puzzles: [
                {
                    image: 'puzzle_a1.png',
                    width: 98,
                    height: 158,
                    dropArea: { xMin: 769, xMax: 867, yMin: 171, yMax: 329 }
                },
                {
                    image: 'puzzle_a2.png',
                    width: 134,
                    height: 138,
                    dropArea: { xMin: 829, xMax: 963, yMin: 192, yMax: 330 }
                },
                {
                    image: 'puzzle_a3.png',
                    width: 131,
                    height: 157,
                    dropArea: { xMin: 924, xMax: 1055, yMin: 170, yMax: 327 }
                },
                {
                    image: 'puzzle_a4.png',
                    width: 119,
                    height: 140,
                    dropArea: { xMin: 1020, xMax: 1139, yMin: 190, yMax: 330 }
                },
                {
                    image: 'puzzle_b1.png',
                    width: 98,
                    height: 124,
                    dropArea: { xMin: 769, xMax: 867, yMin: 292, yMax: 416 }
                },
                {
                    image: 'puzzle_b2.png',
                    width: 135,
                    height: 143,
                    dropArea: { xMin: 828, xMax: 963, yMin: 291, yMax: 434 }
                },
                {
                    image: 'puzzle_b3.png',
                    width: 134,
                    height: 144,
                    dropArea: { xMin: 923, xMax: 1057, yMin: 292, yMax: 436 }
                },
                {
                    image: 'puzzle_b4.png',
                    width: 121,
                    height: 122,
                    dropArea: { xMin: 1018, xMax: 1139, yMin: 292, yMax: 414 }
                },
                {
                    image: 'puzzle_c1.png',
                    width: 113,
                    height: 142,
                    dropArea: { xMin: 769, xMax: 882, yMin: 379, yMax: 521 }
                },
                {
                    image: 'puzzle_c2.png',
                    width: 116,
                    height: 141,
                    dropArea: { xMin: 846, xMax: 962, yMin: 398, yMax: 539 }
                },
                {
                    image: 'puzzle_c3.png',
                    width: 153,
                    height: 140,
                    dropArea: { xMin: 921, xMax: 1074, yMin: 398, yMax: 538 }
                },
                {
                    image: 'puzzle_c4.png',
                    width: 99,
                    height: 157,
                    dropArea: { xMin: 1039, xMax: 1138, yMin: 379, yMax: 536 }
                },
                {
                    image: 'puzzle_d1.png',
                    width: 116,
                    height: 131,
                    dropArea: { xMin: 768, xMax: 884, yMin: 485, yMax: 616 }
                },
                {
                    image: 'puzzle_d2.png',
                    width: 114,
                    height: 115,
                    dropArea: { xMin: 848, xMax: 962, yMin: 502, yMax: 617 }
                },
                {
                    image: 'puzzle_d3.png',
                    width: 148,
                    height: 116,
                    dropArea: { xMin: 925, xMax: 1073, yMin: 501, yMax: 617 }
                },
                {
                    image: 'puzzle_d4.png',
                    width: 100,
                    height: 116,
                    dropArea: { xMin: 1038, xMax: 1138, yMin: 500, yMax: 616 }
                }
            ]
        };
    },

    computed: {
        result () {
            let numCorrect = this.puzzles.filter(puzzle => puzzle.inDropArea).length;

            return {
                stars: Math.floor(numCorrect / 4),
                wrong: this.puzzles.length - numCorrect,
                correct: numCorrect
            };
        }
    },

    created () {
        _.shuffle(this.puzzles).forEach((puzzle, index) => {
            this.$set(puzzle, 'x', 50 + (index % 4 * 150));
            this.$set(puzzle, 'y', 150 + (Math.floor(index / 4) * 150));
            this.$set(puzzle, 'inDropArea', false);
            this.$set(puzzle, 'zIndex', 4);
        });
    },

    methods: {
        dragend (puzzle, { x, y }) {
            puzzle.zIndex--;
            puzzle.x = x;
            puzzle.y = y;

            puzzle.inDropArea = puzzle.x >= puzzle.dropArea.xMin - puzzle.width / 2 &&
                puzzle.x <= puzzle.dropArea.xMax - puzzle.width / 2 &&
                puzzle.y >= puzzle.dropArea.yMin - puzzle.height / 2 &&
                puzzle.y <= puzzle.dropArea.yMax - puzzle.height / 2;

            if (puzzle.inDropArea) {
                this.$nextTick(() => {
                    puzzle.x = puzzle.dropArea.xMin;
                    puzzle.y = puzzle.dropArea.yMin;
                });
            }
        }
    }
};
